import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";

const displayType = {
  CALLERS_CLI: "Caller's CLI",
  DIALLED_NUMBER: "Number as Dialled",
};

const CliPresentation = (props) => (
  <SummaryItem itemKey={"Display Number: "}>
    <SectionItem itemKey={"Display Type"}>
      {displayType[props.module.cliPresentationType]}
    </SectionItem>
  </SummaryItem>
);

export default CliPresentation;
CliPresentation.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
